module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_2_03-b57c6ef05884359dd419060518d41811.jpg";